import { HomeWardWithStudents, StudentListing} from '../../shared';

export class SelectableLocalStudents {
    homeWardStudents: HomeWardWithStudents;
    selectedStudents: StudentListing[];

    constructor (homeWardStudents: HomeWardWithStudents) {
        this.homeWardStudents = homeWardStudents;
        this.selectedStudents = [];
    }
}
